<script>
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { tweened } from "svelte/motion"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import Deudas from "../components/persona/Deudas.svelte"
  import General from "../components/persona/General.svelte"
  import Historico from "../components/persona/Historico.svelte"
  import Laboral from "../components/persona/Laboral.svelte"
  import Spinner from "../components/Spinner.svelte"
  import { verifySession } from "../services/verifySession"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"
  import Sidebar from "../components/Sidebar.svelte"
  import Cabecera from "../components/persona/Cabecera.svelte"
  import EvolucionDeudas from "../components/persona/Evolucion_deudas.svelte"

  export let documento

  let nombres = ""
  let score = 0
  let categoria = ""
  let ops = "score"

  let estadoInicial = 0
  let loading = true
  const planesSinHistoricoDeudas = [
    "Bronze I",
    "Bronze II",
    "Silver I",
    "Ilimitado I",
  ]

  $: mostrarHistoricoDeudas =
    $user && !planesSinHistoricoDeudas.includes(($user.plan || "").trim())

  onMount(() => {
    async function cargar() {
      if (!$user) {
        navigate("/", { replace: true })
        return
      }

      if (
        $user.id_cliente == "28" &&
        ["40887547", "40127983", "41528564", "41980112", "40500254"].includes(
          documento,
        )
      ) {
        navigate("/persona", { replace: true })
        return
      }

      if (!$user.permisos.includes("persona")) {
        user.setUser(null)
        navigate("/", { replace: true })
        return
      }

      if ($user.actualizar_clave == "1") {
        navigate("/seguridad", { replace: true })
        return
      }

      if ($user.verificar == "1") {
        navigate("/verificar", { replace: true })
        return
      }

      try {
        await verifySession($user.session_key)
        await getPuntos()

        if (!$user) return

        const consultas = $user.consultas - $user.consumo
        if (consultas <= 0) {
          navigate("/inicio", { replace: true })
          return
        }

        await registrar()
        await getScore()
      } catch (error) {
        console.error("No se pudo cargar la consulta:", error)
      }
    }

    void cargar()
  })

  const registrar = async () => {
    let formData = new FormData()
    formData.append("documento", documento)
    formData.append("tipo", "persona")
    formData.append("session_key", $user.session_key)

    const response = await fetch(`${BASE_URL}consulta.php`, {
      method: "POST",
      body: formData,
    })

    const resp = await response.json()
    if (resp.status == "error") {
      user.setUser(null)
      navigate("/", { replace: true })
    }

    nombres = resp.data.nombres

    loading = false
    getPuntos()
  }

  $: {
    actualizarPagina(documento)
  }

  const actualizarPagina = (doc) => {
    if (estadoInicial > 0) {
      document.location.reload()
    }
    estadoInicial++
  }

  const getPuntos = async () => {
    let url = `${BASE_URL}session.php?session_key=${$user.session_key}`
    const response = await fetch(url)
    const resp = await response.json()

    if (resp.status === "success") {
      let temp_user = $user
      temp_user.consumo = resp.data.consumo
      temp_user.consultas = resp.data.consultas
      temp_user.inicio = resp.data.inicio
      temp_user.fin = resp.data.fin
      user.setUser(temp_user)
    } else {
      navigate("/", { replace: true })
    }
  }

  const getScore = async () => {
    let url = `${BASE_URL}persona.php?documento=${documento}&ops=${ops}&session_key=${$user.session_key}`

    try {
      const response = await fetch(url, { method: "GET" })

      if (!response.ok) {
        score = 0
        categoria = ""
        return
      }

      const resp = await response.json()
      const scoreRaw = Number(resp?.data?.score)

      if (resp.status === "ok" && Number.isFinite(scoreRaw)) {
        score = Math.min(Math.max(scoreRaw, 0), 999)
        categoria =
          typeof resp?.data?.categoria === "string"
            ? resp.data.categoria.trim()
            : ""
      } else {
        score = 0
        categoria = ""
      }
    } catch (error) {
      console.error("Error al obtener el score:", error)
      score = 0
      categoria = ""
    }
  }

  // Tiempo de sessión
  let original = 20 * 60
  let timer = tweened(original)

  setInterval(() => {
    if ($timer > 0) $timer--
  }, 1000)

  $: minutes = Math.floor($timer / 60)

  $: if (minutes <= 0) {
    user.setUser(null)
    navigate("/", { replace: true })
  }
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row page-shell">
    <Sidebar />

    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />
      {#if loading}
        <div class="p-5">
          <Spinner />
        </div>
      {:else}
        <div class="container-fluid py-5 bg-2">
          <Cabecera {documento} {nombres} {score} {categoria} />

          <div
            class="d-flex flex-wrap align-items-center gap-3 border-bottom mt-3"
          >
            <ul class="nav nav-tabs border-0" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-general-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#pills-general"
                  type="button"
                  role="tab"
                  aria-controls="pills-general"
                  aria-selected="true"
                  ><i class="bi-person me-1"></i> Información General</button
                >
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-laboral-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#pills-laboral"
                  type="button"
                  role="tab"
                  aria-controls="pills-laboral"
                  aria-selected="false"
                  ><i class="bi bi-briefcase me-1"></i> Datos Laborales</button
                >
              </li>
              {#if mostrarHistoricoDeudas}
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-historico-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#pills-historico"
                    type="button"
                    role="tab"
                    aria-controls="pills-historico"
                    aria-selected="false"
                    ><i class="bi bi-calendar2-check me-1"></i> Histórico</button
                  >
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-deudas-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#pills-deudas"
                    type="button"
                    role="tab"
                    aria-controls="pills-deudas"
                    aria-selected="false"
                    ><i class="bi-graph-up-arrow me-1"></i> Deudas</button
                  >
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-evolucion-deudas-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#pills-evolucion-deudas"
                    type="button"
                    role="tab"
                    aria-controls="pills-evolucion-deudas"
                    aria-selected="false"
                    ><i class="bi bi-graph-up me-1" aria-hidden="true"></i> Evolución
                    de deudas</button
                  >
                </li>
              {/if}
            </ul>
          </div>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade mb-7 show active"
              id="pills-general"
              role="tabpanel"
              aria-labelledby="pills-general-tab"
            >
              <General {documento} />
            </div>
            <div
              class="tab-pane fade"
              id="pills-laboral"
              role="tabpanel"
              aria-labelledby="pills-laboral-tab"
            >
              <Laboral {documento} />
            </div>
            {#if mostrarHistoricoDeudas}
              <div
                class="tab-pane fade"
                id="pills-historico"
                role="tabpanel"
                aria-labelledby="pills-historico-tab"
              >
                <Historico {documento} />
              </div>
              <div
                class="tab-pane fade"
                id="pills-deudas"
                role="tabpanel"
                aria-labelledby="pills-deudas-tab"
              >
                <Deudas {documento} />
              </div>
              <div
                class="tab-pane fade"
                id="pills-evolucion-deudas"
                role="tabpanel"
                aria-labelledby="pills-evolucion-deudas-tab"
              >
                <EvolucionDeudas {documento} />
              </div>
            {/if}
          </div>
        </div>
      {/if}
      <Footer />
    </div>
  </main>
{/if}

<style>
  .page-shell {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .page-content {
    min-width: 0;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  @media (max-width: 767.98px) {
    .page-shell {
      height: auto;
      min-height: 100vh;
      overflow: visible;
    }

    .page-content {
      overflow: visible;
    }
  }
</style>
